export default __webpack_public_path__ + "static/hfeatures-3-f6e7e7609e02a9b153caa4ba969d0493.png";